module.exports = __webpack_public_path__ + "static/media/white-paper.8d5d02a7.png";